<template>
  <span class="user-avatar" :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${size * 0.38}px` }">
    <img v-if="src && !failed" :src="apiUrl(src)" :alt="name" loading="lazy" decoding="async" @error="failed = true" />
    <span v-else aria-hidden="true">{{ initials }}</span>
  </span>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { apiUrl } from "@/api/http.js";

const props = defineProps({
  src: { type: String, default: "" },
  name: { type: String, default: "" },
  size: { type: Number, default: 36 },
});

const failed = ref(false);
watch(() => props.src, () => (failed.value = false));

const initials = computed(() =>
  (props.name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase()
);
</script>

<style scoped>
.user-avatar {
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background: hsl(var(--primary) / 0.14);
  color: hsl(var(--primary));
  font-weight: 700;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
